<script>
  import Dialog from './Dialog';
  import RoomCreateDialog from './RoomCreateDialog';
  import {prompt} from '../Prompt';
  import eventBus from '../../assets/js/event-bus';
  import {routeOptions} from '../../assets/js/utils';


  export default {
    name: 'RoomUpdateDialog',

    extends: RoomCreateDialog,

    data() {
      return {
        title: 'Raum bearbeiten',
        submit: 'Raum speichern',
        operationId: 'RoomUpdate',
        errorMessage: 'Raum konnte nicht gespeichert werden.',
        loading_delete: false,
        // Dialog
        routePath: '/share/rooms/update/:updateRoomId'
      };
    },

    computed: {
      updateRoomId() {
        return this.$route.params.updateRoomId;
      }
    },

    watch: {
      loading_delete(loading_delete) {
        this.$emit('loading-delete', loading_delete);
      }
    },

    methods: {
      async show() { // Called by Dialog
        try {
          const {data: room} = await this.$api.post('RoomGet', {roomId: this.updateRoomId});

          this.room = room;
          this.reset(); // resets formData
          this.formData.id = room.id;
          this.formData.name = room.name || '';
          this.formData.description = room.description || '';
          this.formData.private = !!room.private;

          Dialog.methods.show.call(this);

        } catch (error) {
          eventBus.$emit('notifyUser', 'Raum konnte nicht geladen werden');
          this.$router.replace(routeOptions({path: '/share/rooms'}));
        }
      },

      async delete() {
        const {room} = this;

        try {
          this.loading = true;
          this.loading_delete = true;

          await prompt({
            title: `Raum "${room.name}" löschen?`,
            content: 'Dieser Raum (inkl. aller hochgeladenen Dateien) wird für alle Benutzer unwiderruflich gelöscht.'
          });

          await this.$api.post('RoomDelete', {id: room.id});

          const activeRoom = this.$store.getters['share/getRoom'];
          const activeRoomId = activeRoom ? activeRoom.id : null;
          const roomId = activeRoomId && activeRoomId !== room.id ? activeRoomId : 'local';
          this.$router.replace({path: '/share/rooms', query: {room: roomId}});

        } catch (error) {
          if (error.message !== 'declined') {
            this.error = 'Raum konnte nicht gelöscht werden.';
          }
        }

        this.loading = false;
        this.loading_delete = false;
      }
    }
  };
</script>
